import type { InputMode } from './InputOTP.types';

const getValidationPattern = (inputMode: InputMode) => {
  if (inputMode === 'numeric') {
    return /^[0-9]$/;
  }
  // default to uppercase text
  return /^[A-Z0-9]$/;
};

const getPastePattern = (inputMode: InputMode) => {
  if (inputMode === 'numeric') {
    return /[0-9]/g;
  }
  // default to uppercase text
  return /[A-Z0-9]/g;
};

export const isValidChar = (char: string, inputMode: InputMode) => {
  const pattern = getValidationPattern(inputMode);
  return pattern.test(char);
};

export const extractValidChars = (text: string, inputMode: InputMode) => {
  const pattern = getPastePattern(inputMode);
  return text.match(pattern) || [];
};
